// lib/cache.js
const NodeCache = require("node-cache");
const tokenCache = new NodeCache({ stdTTL: 3600, checkperiod: 600 }); // TTL in seconds

module.exports = tokenCache;
